<a [routerLink]="['/', type, post.slug]" class="post-card">
  <img [ngSrc]="post.image_info.big" width="600" height="480" [alt]="post.title"
      [title]="post.title" class="post-card__img" />
  <div class="post-card__content">
    <h3 class="post-card__title">{{ post.title }}</h3>
    <p class="post-card__description" [innerHTML]="post.text_short ? post.text_short : post.text"></p>
  </div>
</a>
